<template>
  <div class="avatar" :style="avatarStyle"></div>
</template>

<script>
export default {
  name: 'BaseAvatar',
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      required: false
    }
  },
  computed: {
    avatarStyle() {
      let size = 60
      const sizeType = typeof this.size
      if (sizeType === 'number') {
        size = this.size
      } else if (sizeType === 'string') {
        switch (this.size) {
          case 'large':
            size = 96
            break
          case 'medium':
            size = 60
            break
          case 'small':
            size = 40
            break
        }
      }

      size += 'px'

      return {
        backgroundImage: `url(${this.src})`,
        width: size,
        height: size
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  width: 60px;
  height: 60px;
  background: no-repeat center;
  background-size: contain;
  border-radius: 50%;
}
</style>
